// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 2V4H9V2H11V4H13V2H15V4H17V2H19V14H21V13H23V22H15.5V14H8.5V22H1V13H3V14H5V2H7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 22V16H10.5V22H13.5Z"}}]};

const CastleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-filled',
    ref,
    icon: element,
  },
));

CastleFilledIcon.displayName = 'CastleFilledIcon';

export default CastleFilledIcon;
